var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ColorPalette = function ColorPalette(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M7.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM12 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM16.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4a8 8 0 0 0 0 16c.03 0 .06.001.091.004a.3.3 0 0 0 .275-.467A3 3 0 0 1 14.007 14H16.5c.964 0 1.868-.341 2.518-.919.646-.574.982-1.326.982-2.081 0-1.816-.81-3.585-2.3-4.91C16.206 4.764 14.157 4 12 4ZM8.173 2.761A10 10 0 0 1 12 2c2.617 0 5.146.923 7.028 2.596C20.914 6.272 22 8.572 22 11c0 1.367-.612 2.65-1.654 3.576C19.308 15.498 17.923 16 16.5 16h-2.516a1 1 0 0 0-.5 1.875 1 1 0 0 1 .194.14A2.3 2.3 0 0 1 11.96 22 10 10 0 0 1 8.173 2.76ZM12 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-1.5-.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-3 3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM6 10.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm10.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-1.5-.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default ColorPalette;